import React, { useState } from 'react';
import {
  TouchableOpacity,
  StyleSheet,
  Platform,
  Alert,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useAuth } from '@/contexts/AuthContext';

interface TestNotificationButtonProps {
  isVisible?: boolean;
}

const TestNotificationButton: React.FC<TestNotificationButtonProps> = ({ 
  isVisible = true 
}) => {
  const { user, session } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const sendTestNotification = async () => {
    if (!user?.id) {
      Alert.alert('Erro', 'Usuário não encontrado. Faça login primeiro.');
      return;
    }

    setIsLoading(true);

    try {
      // FIX: Always use production API - abandon all localhost usage
      const API_URL = 'https://mobile.padrinho.app';
      
      // Log if we're overriding a localhost configuration
      const envUrl = process.env.EXPO_PUBLIC_API_URL;
      if (envUrl && (
        envUrl.includes('localhost') || 
        envUrl.includes('127.0.0.1') || 
        envUrl.startsWith('http://10.') || 
        envUrl.startsWith('http://192.168.')
      )) {
        console.log('🔧 TestNotificationButton: Forcing production API, overriding local URL:', envUrl, '→', API_URL);
      }
      
      console.log('🧪 Sending test notification for user:', user.id);

      const response = await fetch(`${API_URL}/api/notifications/test-push`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session?.access_token}`,
        },
        body: JSON.stringify({
          userId: user.id,
          title: '🔔 Test Push',
          message: 'Test notification from admin button',
        }),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        Alert.alert(
          'Sucesso! 🎉', 
          `Notificação de teste enviada para o usuário admin!\n\nVerifique suas notificações no dispositivo.\n\nID OneSignal: ${result.oneSignalId}`,
          [{ text: 'OK', style: 'default' }]
        );
        console.log('✅ Test notification sent successfully:', result.oneSignalId);
      } else {
        const errorMessage = result.error || 'Falha ao enviar notificação de teste';
        Alert.alert('Erro', errorMessage);
        console.error('❌ Test notification error:', result);
      }
    } catch (error) {
      console.error('❌ Test notification request failed:', error);
      Alert.alert(
        'Erro de Rede',
        'Não foi possível enviar a notificação de teste. Verifique sua conexão.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <TouchableOpacity
      style={[styles.testButton, isLoading && styles.testButtonDisabled]}
      onPress={sendTestNotification}
      activeOpacity={0.8}
      disabled={isLoading}
    >
      <Ionicons 
        name={isLoading ? "hourglass-outline" : "notifications-outline"} 
        size={24} 
        color="#FFFFFF" 
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  testButton: {
    position: 'absolute',
    left: 20,
    bottom: Platform.OS === 'ios' ? 30 : 20,
    width: 56,
    height: 56,
    borderRadius: 28,
    backgroundColor: '#3B82F6', // Blue color to differentiate from admin button
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    zIndex: 999, // Slightly lower z-index than admin button
  },
  testButtonDisabled: {
    backgroundColor: '#9CA3AF', // Gray when loading
    opacity: 0.7,
  },
});

export default TestNotificationButton;